  <template>
  <div>
        <!-- 项目立项申请查看详细项目基本内容 -->
        <div class="projectApplication1">
            <div class="vfpHeader">
                <div class="titleOne">项目立项详细</div>
                <el-button @click="back()" type="primary" size="mini">返回</el-button>
            </div>
            <hr>
        </div>

        <!-- 特色创客空间建设项目 -->
        <MakerSpaceWordDetail v-if="$route.query['tid']=='5f7a66d5-c206-11ed-a4cd-509a4c5b67cf'"/>

        <!-- 学生创客项目 -->
        <studentProjectWordDetail v-if="$route.query['tid']=='5e21b204-c206-11ed-a4cd-509a4c5b67cf'"/>
  </div>
</template>

<script>
import MakerSpaceWordDetail from './components/MakerSpaceWordDetail.vue';
import studentProjectWordDetail from './components/studentProjectWordDetail.vue'
    export default {
        components:{MakerSpaceWordDetail,studentProjectWordDetail},
        data() {
            return {
                status:0,
                
            }
        },
        methods:{
           back(){
            this.$router.push('/projectApplication')
           }
        },
        mounted(){
            // console.log(this.$route.query['Id'])
            // this.getData()
        }
    }
</script>

<style lang="less">

</style>